import React from "react";

function YellowBox() {
  return <div className="w-1/2 h-2 bg-yellow -mb-5 " />;
}

export default YellowBox;
